import {TimelineLite} from "gsap";
import {TheRave} from "../../TheRave";
import {TheRaveGameConfig} from "../../TheRaveGameConfig";
import {BetWinMode} from "../../../core/config/BetWinMode";
import {IBetWayWinData} from "../../server/data/ITheRaveData";
import {IndividualWinView} from "./IndividualWinView";

export class IndividualWinController {

    private _view:IndividualWinView;
    private _currentTimeline:TimelineLite | null;
    private _stopped:boolean;

    constructor() {
        this._view = new IndividualWinView();
    }

    public start():void {
        if(TheRave.isWinBelowStake()){
            return;
        }
        if(TheRave.model.parsedGameData.betWins.length > 0 && TheRave.model.parsedGameData.singleWin > 0) {
            this._stopped = false;
            // Add a small delay for the first time so we don't start to play before the autoPlay start next spin.
            this.playNextBetWin(0, 1);
        }
    }

    private playNextBetWin(index:number, delay:number = 1.5):void {
        // TODO: reset all win state if needed.

        const data = TheRave.model.parsedGameData;
        const winRatio = data.currentWinRatioConfig?.ratio!;
        if(index === data.betWins.length) {
            index = 0;
        }
        const tl = new TimelineLite();
        if(TheRaveGameConfig.BET_WIN_MODE === BetWinMode.BET_WAY) {
            tl.add(this.getBetWayAnimation(<IBetWayWinData>data.betWins[index], winRatio), delay);
        }
        tl.add(() => {
            if(!this._stopped) {
                this.playNextBetWin(index + 1);
            }
        });
        this._currentTimeline = tl;
    }

    private getBetWayAnimation(winData:IBetWayWinData, winRatio:number):TimelineLite {
        const tl = new TimelineLite(),
            winNumPlayPosition: number[] = TheRave.individualWin.view.findLastNoWildSymbolPosition(winData);
        winData.reelWinPositions.forEach((pos:number[]) => {
                    tl.add(this.getSymbolWinAnimation(pos[0], pos[1], winRatio), 0);

        });
        if(TheRave.apiPlugin.gameClientConfiguration.displayIndividualWinsInGame){
            tl.add(TheRave.individualWin.view.playWinNumbers(winData, false, winNumPlayPosition),0);
        }

        return tl;
    }

    private getSymbolWinAnimation(reelId:number, symId:number, winRatio:number):TimelineLite {
        const tl = new TimelineLite();
        const sym = TheRave.reels[reelId].getSymbol(symId, false, false);
        tl.add([
           this._view.playAnimation(sym.getStagePosition(), sym.symbolHeight, this.getEffectLevel(winRatio)),
            () => {
            if(!sym.destroyed) { // Sometimes initial win timeline is still going when symbol started to spin away.
                TheRave.reels[reelId].reelView.addWinSymbol(sym);
            }
        }]);// no need to have win state in this game?

       // const position = sym.getStagePosition();
       // tl.add(this._view.playAnimation(position, this.getEffectLevel(winRatio), reelId === 4));

        return tl;
    }

    private getEffectLevel(winRatio:number):number {
        for(let i = 1; i < 4; i++) {
            if(winRatio < TheRaveGameConfig.WIN_RATIOS[i].ratio) {
                return i - 1;
            }
        }
        return 3;
    }

    public async stop():Promise<any> {
        this._stopped = true;
        if(this._currentTimeline && this._currentTimeline.isActive()) {
            await this._currentTimeline.progress(1);
            this._currentTimeline.kill();
        }
        this._currentTimeline = null;
        this._view.stop();
        await Promise.resolve();
    }

    public get view():IndividualWinView{
        return this._view;
    }
}